export const questions = [
  {
    name: '51cf8f1b-7677-438e-9595-a15807bed575',
    textId: 'screenings.form.likert.adult-ucla3.question-1',
    options: [
      {
        name: 'f0db37fe-66c5-4238-8955-89ba7f4a6758',
        textId: 'screenings.form.likert.adult-ucla3.answer-hardly',
      },
      {
        name: 'a379b070-5c1d-4dbd-a6a5-43056c9b25eb',
        textId: 'screenings.form.likert.adult-ucla3.answer-sometimes',
      },
      {
        name: '863c244e-0914-4f2d-a795-35963b84201d',
        textId: 'screenings.form.likert.adult-ucla3.answer-often',
      },
    ],
  },
  {
    name: '255ea238-b3ab-4799-aa82-ec886be9da86',
    textId: 'screenings.form.likert.adult-ucla3.question-2',
    options: [
      {
        name: 'f44d66cc-ce07-416d-88e7-bae59abce2d6',
        textId: 'screenings.form.likert.adult-ucla3.answer-hardly',
      },
      {
        name: '7538b3bf-02c8-4989-8ae4-503a1837357c',
        textId: 'screenings.form.likert.adult-ucla3.answer-sometimes',
      },
      {
        name: '663ab25e-fdba-48cd-8135-51b4c8afc8d8',
        textId: 'screenings.form.likert.adult-ucla3.answer-often',
      },
    ],
  },
  {
    name: 'dac97d9a-0471-4ba0-a0ff-60fc98601b4b',
    textId: 'screenings.form.likert.adult-ucla3.question-3',
    options: [
      {
        name: 'b5fca7cf-ef1c-4432-88f9-9586bd466b5b',
        textId: 'screenings.form.likert.adult-ucla3.answer-hardly',
      },
      {
        name: 'b2620eb0-02d7-4b5e-afdd-58f0df859cf1',
        textId: 'screenings.form.likert.adult-ucla3.answer-sometimes',
      },
      {
        name: 'e79c41c9-b652-48a4-ba2e-671575794315',
        textId: 'screenings.form.likert.adult-ucla3.answer-often',
      },
    ],
  },
];
